import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonPosition, ToastType } from '../toast.type';

@Component({
  selector: 'mode-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  @Input() type: ToastType = 'success';
  @Input() hideIcon = false;
  @Input() showCloseBtn = false;
  @Input() closeBtnPosition: ButtonPosition = 'center';
  @Input() canTapToDismiss = false;
  @Output() dismissToast = new EventEmitter();
}
